import { Button, Card, Container, Typography } from '@mui/material';
import React, { useState } from 'react';
import CardMedia from '@mui/material/CardMedia';
import TextField from '@mui/material/TextField';
import { Grid } from '@material-ui/core';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const AddCourse = () => {
    const initialInfo = { courseName: '', price: 0, category: '', rating: 0, description: '', image: '' };
    const [courseInfo, setCourseInfo] = useState(initialInfo);


    // handleOnBlur function call 
    const handleOnBlur = e => {
        const field = e.target.name;
        const value = e.target.value;
        const newCourseInfo = { ...courseInfo };
        newCourseInfo[field] = value;
        setCourseInfo(newCourseInfo);
    }

    const handleAddCourse = e => {
        // collect data
        const course = {
            ...courseInfo
        }
        // console.log(course);
        // send to the server

        fetch('https://warm-oasis-84574.herokuapp.com/explore', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(course)
        })
            .then(res => res.json())
            .then(data => {
                if (data.insertedId) {
                    alert('course added successfully!');
                }
            })

        e.preventDefault();
    }
    return (
        <Container sx={{ mt: 2 }}>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 6, sm: 6, md: 12 }}  >
                <Grid item xs={12} md={6} >
                    <Card sx={{ minWidth: 275, border: 0, boxShadow: 0 }}>
                        <CardMedia
                            component="img"
                            style={{ width: 'auto', height: '300px', margin: '0 auto' }}
                            image="https://image.freepik.com/free-vector/webinar-concept-illustration_114360-4764.jpg"
                            alt="Course Photo"
                        />


                    </Card>

                </Grid>
                <Grid item xs={12} md={6}>

                    <Typography variant="h5" component="div" sx={{ fontWeight: 500, m: 2, color: 'info.main' }} >
                        Please add a course
                    </Typography>
                    <form onSubmit={handleAddCourse}>

                        <TextField
                            sx={{ width: '100%', m: 1 }}
                            id="standard-size-normal"
                            name="courseName"
                            onBlur={handleOnBlur}
                            label="course Name"
                            size="small"
                        />
                        <TextField
                            sx={{ width: '100%', m: 1 }}
                            id="standard-size-normal"
                            name="price"
                            onBlur={handleOnBlur}
                            size="small"
                            label="Price"
                            type="number"
                        />
                        <TextField
                            sx={{ width: '100%', m: 1 }}
                            id="standard-size-normal"
                            name="category"
                            onBlur={handleOnBlur}
                            size="small"
                            label="Category"
                        />



                        <TextField
                            sx={{ width: '100%', m: 1 }}
                            id="outlined-size-small"
                            name="rating"
                            onBlur={handleOnBlur}
                            type="number"
                            label="Rating"
                        />
                        <TextField
                            sx={{ width: '100%', m: 1 }}
                            id="outlined-multiline-flexible"
                            multiline
                            name="description"
                            onBlur={handleOnBlur}
                            label="Course Details"
                        />
                        <TextField
                            sx={{ width: '100%', m: 1 }}
                            id="outlined-multiline-flexible"
                            multiline
                            name="image"
                            onBlur={handleOnBlur}
                            label="Image Url"
                        />


                        <Button type="submit" variant="outlined" sx={{ mt: 2, color: 'success.main' }}>
                            <AddCircleOutlineIcon />
                            Add </Button>
                    </form>

                </Grid>

            </Grid>
        </Container>
    );
};

export default AddCourse;